export class FinanceTransfer {
    constructor(
        public id: string,
        public transfer_type: string,
        public created_at: Date,
        public sent_from: string,
        public sent_to: string,
        public amount: number,
        public is_sent: boolean,
        public note: string
    ) { }

}
